import axios from 'axios'
import {BASE_URL, API_VERSION, WINNERS} from '../endpoints'

export const GET_ALL_WINNERS = 'GET_ALL_WINNERS'
export const ADD_WINNER = 'ADD_WINNER'
export const EDIT_WINNER = 'EDIT_WINNER'
export const DELETE_WINNER = 'DELETE_WINNER'

export const getAllItems = (page, size, search, id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${WINNERS}?page=${page}&size=${size}&search=${search}&raffleid=${id}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_WINNERS,
                payload: {
                    winners: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};



export const addItem = (payload) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + WINNERS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_WINNER, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + WINNERS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_WINNER, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + WINNERS + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_WINNER, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}